import { request } from "@/util/request";

const apiLiveStream = {
  requestLiveStream(data) {
    return request({
      url: "/api/live/request-live",
      method: "post",
      data: data,
    });
  },
};
export default apiLiveStream;
